import { Typography, styled } from '@mui/material'
import { ViewIcon } from '$common/icons/view'
import { formatViews } from '$func/text'
import { useOpenedRoom } from '$logic/opened-room'

const Container = styled('div')`
  display: flex;
  /* @noflip */
  margin-right: 8px;
  flex-direction: row;
  align-items: center;
`

const ViewsTypography = styled(Typography)`
  font-size: 12px;
  font-weight: 400;
  line-height: 12px;
  letter-spacing: -0.5px;
  padding-top: 2px;
  /* @noflip */
  margin-right: 4px;
`

const PostfixTypography = styled(ViewsTypography)`
  padding-bottom: 1px;
  /* @noflip */
  margin-right: 2px;
`

export function Views({ views, fromMe }: { views: number; fromMe: boolean }) {
  const { openedRoom } = useOpenedRoom()
  const isChannel = openedRoom?.type === 'CHANNEL'
  if (!isChannel) return null

  const { shortenedViews, postfix } = formatViews(views || 1)
  return (
    <Container>
      <ViewIcon />

      <ViewsTypography
        variant="caption1"
        color={fromMe ? 'neutral000' : 'neutral500'}
      >
        {shortenedViews}
      </ViewsTypography>
      <PostfixTypography
        variant="caption1"
        color={fromMe ? 'neutral000' : 'neutral500'}
      >
        {postfix}
      </PostfixTypography>
    </Container>
  )
}
